var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 56,
    viewBox: "0 0 140 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0207 20C86.0207 4 113.521 -1.5 142.021 -2V68.5C96.0207 71.1667 4.42069 73.4 6.02069 61C8.02069 45.5 26.5207 38.5 40.5207 39.5C54.5207 40.5 62.0207 36 74.0207 20Z",
    fill: "#F8DBB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.414 56.4827L42.0984 56.5225C39.6935 56.5225 37.7617 54.5735 37.7617 52.1472L109.751 52.1074C109.751 54.5337 107.819 56.4827 105.414 56.4827Z",
    fill: "#3D5AC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.414 54.9713L42.0984 55.011C40.2455 55.011 38.6291 53.8178 38.0377 52.1472H37.7617C37.7617 54.5735 39.6935 56.5225 42.0984 56.5225L105.414 56.4827C107.819 56.4827 109.751 54.5337 109.751 52.1074H109.475C108.883 53.778 107.306 54.9713 105.414 54.9713Z",
    fill: "#5571E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8564 53.6182H69.6955C68.907 53.6182 68.2368 52.9818 68.2368 52.1465H79.3151C79.3151 52.942 78.6449 53.6182 77.8564 53.6182Z",
    fill: "#27429C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.045 52.1078L41.4676 52.1476L41.4282 12.8098C41.4282 10.5426 43.2417 8.71289 45.4889 8.71289H101.984C104.231 8.71289 106.045 10.5426 106.045 12.8098V52.1078Z",
    fill: "#5571E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.694 12.1348H44.8187V48.7679H102.694V12.1348Z",
    fill: "#312C76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.733 45.2266H44.8582V48.7268H102.733V45.2266Z",
    fill: "#151247"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.694 12.1348H44.8187V13.8849H102.694V12.1348Z",
    fill: "#151247"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M64.0973 12.1328L44.8187 31.6227L44.8581 48.7659H44.8976L81.1287 12.1328H64.0973Z",
    fill: "#5571E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M52.3094 48.7667H60.8645L97.135 12.0938L88.5799 12.1335L52.3094 48.7667Z",
    fill: "#5571E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M95.8734 48.7275L102.694 41.8464V28.8398L82.272 48.7275H95.8734Z",
    fill: "#5571E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.084 27.7656H41.4677V34.965H106.084V27.7656Z",
    fill: "#F5D100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5984 34.8665H43.8904L48.7888 27.7832H54.4968L49.5984 34.8665Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0887 34.8665H55.3807L60.2791 27.7832H65.9871L61.0887 34.8665Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4412 34.8665H67.7549L72.675 27.7832H78.3613L73.4412 34.8665Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9315 34.8665H79.2452L84.1653 27.7832H89.8516L84.9315 34.8665Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8518 34.8665H91.6194L96.1096 27.7832H101.342L96.8518 34.8665Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1662 51.2836C33.1662 51.2836 23.9665 48.6317 23.0673 51.144C22.1681 53.6563 16.7728 64.7523 16.7728 64.7523L20.7847 66.8459L26.8025 56.3082L34.8954 55.6103L33.1662 51.2836Z",
    fill: "#14103D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4113 50.8652L25.6958 51.284C25.6958 51.284 24.4508 51.3537 24.5199 54.2848C24.5891 57.2158 24.5891 69.1492 24.5891 69.1492L28.7393 69.2888L29.5694 56.7971L38.2849 56.6575C40.1525 56.6575 41.8126 55.5409 42.5734 53.866C42.8501 53.238 42.9884 52.4703 42.7809 51.7027L34.4113 50.8652Z",
    fill: "#231C61"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1799 49.1212C26.1799 49.9587 25.6265 50.0982 24.7965 50.0982C23.9664 50.0982 23.2056 49.9587 23.2056 49.1212C23.2056 48.2838 23.8973 47.5859 24.7273 47.5859C25.4882 47.5859 26.1799 48.2838 26.1799 49.1212Z",
    fill: "#E1AD9D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2174 49.96H25.4881C25.0039 49.96 24.6581 49.6111 24.6581 49.1226C24.6581 48.6341 25.0039 48.2852 25.4881 48.2852H27.2174C27.7016 48.2852 28.0474 48.6341 28.0474 49.1226C28.0474 49.5413 27.7016 49.96 27.2174 49.96Z",
    fill: "#E1AD9D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1483 50.0986L26.595 47.2373L33.7195 46.4697L35.1721 38.0953C35.3105 37.3277 36.4172 36.4204 37.1781 36.56L36.9706 36.4902C37.7314 36.6298 38.4231 37.537 38.2848 38.3047L36.9014 48.3539C36.8322 48.9122 36.4172 49.3309 35.8638 49.4705L27.1483 50.0986Z",
    fill: "#C8C6F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3283 36.7689C41.4666 36.7689 41.605 36.8386 41.7433 36.8386H41.8125C43.0575 37.3271 43.8876 38.6531 43.8876 39.9092L42.7809 51.7729C35.4488 51.7031 34.342 50.8657 34.342 50.8657L34.8954 38.7229C34.9646 37.6063 35.5179 36.4897 36.8322 36.4199L41.3283 36.7689Z",
    fill: "#D8D7FD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2353 50.028C33.3045 50.8654 32.7511 51.005 31.9211 51.0748C31.091 51.1446 30.3302 51.0748 30.261 50.2373C30.1918 49.3999 30.8144 48.702 31.6444 48.6322C32.4744 48.5625 33.1661 49.1905 33.2353 50.028Z",
    fill: "#EB8175"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.342 50.796L32.6127 50.9355C32.1285 50.9355 31.7827 50.5866 31.7135 50.1679C31.7135 49.6794 32.0594 49.3305 32.4744 49.2607L34.2036 49.1211C34.6878 49.1211 35.0337 49.47 35.1029 49.8887C35.172 50.3772 34.8262 50.796 34.342 50.796Z",
    fill: "#EB8175"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2729 51.0069L33.512 48.2154L41.2591 46.9593L40.8441 39.7015C40.9133 38.9338 41.7433 38.0964 42.5042 38.1662C43.2651 38.236 44.026 39.0734 43.9568 39.8411L44.5101 48.5643C44.441 49.1226 44.0951 49.5414 43.5418 49.7507L34.2729 51.0069Z",
    fill: "#D8D7FD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9229 41.3047L29.3617 42.1421C29.6384 42.1421 29.8459 42.4213 29.9151 42.7004L30.8143 50.3769C30.8835 50.7258 30.5376 51.0748 30.1918 51.005L21.6146 50.1676C21.3379 50.1676 21.1304 49.8884 21.0613 49.6093L20.3004 41.9328C20.2312 41.5838 20.5079 41.3047 20.9229 41.3047Z",
    fill: "#091218"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4388 41.3059L28.8776 42.0736C29.1543 42.0736 29.3618 42.3527 29.431 42.6318L30.3302 50.3084C30.3994 50.6573 30.0535 51.0062 29.7076 50.9364L21.1305 50.099C20.8538 50.099 20.6463 49.8198 20.5771 49.5407L19.8163 41.8642C19.7471 41.5851 20.0238 41.2361 20.4388 41.3059Z",
    fill: "#1B2934"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5376 50.3789L36.2788 50.9372C36.4863 50.9372 36.5555 51.0768 36.5555 51.2861C36.5555 51.4955 36.4171 51.5653 36.2096 51.5653L30.1226 51.007L30.5376 50.3789Z",
    fill: "#091218"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2806 45.9841C25.2115 46.4726 24.7964 46.8914 24.2431 46.8216C23.7589 46.7518 23.3439 46.3331 23.413 45.7748C23.4822 45.2863 23.8972 44.8675 24.4506 44.9373C24.9348 45.0071 25.2806 45.4258 25.2806 45.9841Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5674 41.3066L40.7749 46.8198L33.512 48.1457L39.8757 46.1917L40.5674 41.3066Z",
    fill: "#C8C6F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7631 36.0016L37.2473 37.3275C37.4548 37.816 37.8698 38.0951 38.354 38.1649C39.3224 38.2347 39.9449 37.2577 39.599 36.4203L38.769 34.3965L36.7631 36.0016Z",
    fill: "#EB8175"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1781 37.1879C37.1781 37.1879 39.5299 36.6994 39.184 34.6058C38.8382 32.5122 36.6247 34.1173 36.6247 34.1173L36.8322 36.2109L37.1781 37.1879Z",
    fill: "#E16C5F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.512 30.9101C32.6128 32.7943 33.4429 35.0275 35.3105 35.9347C37.1781 36.8419 39.3916 36.0045 40.2908 34.1203C41.19 32.2361 40.3599 30.0029 38.4923 29.0957C36.6247 28.1884 34.3421 29.0259 33.512 30.9101Z",
    fill: "#EB8175"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2849 33.2096C38.2849 33.2096 37.7315 36.2104 39.8758 36.2802C42.0892 36.3499 40.8442 30.6275 40.8442 30.6275L37.3856 27.0684L32.0595 28.3943L32.6129 31.8836C32.6129 31.8836 33.4429 32.3023 38.0082 31.6045L38.2849 33.2096Z",
    fill: "#231C61"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0714 30.9062L37.8698 33.4186L39.3224 31.7437L36.0714 30.9062Z",
    fill: "#231C61"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6623 32.5135C37.3856 33.0717 37.6623 33.6998 38.1465 33.9092C38.6998 34.1883 39.3224 33.9092 39.5299 33.4207C39.8066 32.8624 39.5299 32.2343 39.0457 32.025C38.5615 31.7458 37.939 32.025 37.6623 32.5135Z",
    fill: "#EB8175"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7512 31.8846C32.7512 31.8846 31.9211 28.8838 33.8579 27.0694C35.4488 25.5341 38.0081 25.6736 39.3915 27.3485C40.0141 28.1162 40.5674 29.3025 40.6366 31.117L32.7512 31.8846Z",
    fill: "#F5D100"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1662 31.8129V29.9287C33.1662 29.4402 33.5121 29.0913 33.9963 29.0215C34.4804 29.0215 34.8263 29.3704 34.8955 29.7891L35.103 31.6036",
    stroke: "#F1AB00",
    strokeWidth: 0.2802,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6367 31.1152L32.0595 31.9527",
    stroke: "white",
    strokeWidth: 1.1206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5747 55.5691L54.4777 45.4263C54.6748 44.949 55.3451 44.949 55.5422 45.4263L59.4452 55.5691H50.5747Z",
    fill: "#F5D100"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3808 47.6133H51.4815V49.7611H58.3808V47.6133Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9327 51.6719H51.1266V53.8197H58.9327V51.6719Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1548 55.5684H49.8651V56.4434H60.1548V55.5684Z",
    fill: "#E8C400"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.109 55.6081L111.012 45.4654C111.21 44.9881 111.88 44.9881 112.077 45.4654L115.98 55.6081H107.109Z",
    fill: "#F5D100"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.915 47.6133H108.016V49.7611H114.915V47.6133Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.428 51.7109H107.622V53.8588H115.428V51.7109Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M116.689 55.6074H106.4V56.4825H116.689V55.6074Z",
    fill: "#E8C400"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478:153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance-icon.1ec98a08.svg";
export { ForwardRef as ReactComponent };